<div class="dis-flex">
    <img class="wd-50 m-l-r-auto" src="{{ env.assetUrl }}/no_data_found.png" />
  </div>
  